export default __webpack_public_path__ + "static/media/graphic-04 (1).85e360e8.png";